// extracted by css-extract-rspack-plugin
export default {"container":"_f09e466e"};